
import "./components/ResearchInsights.css";

import marketIcon from "../../assets/images/research/market.png";
import audienceIcon from "../../assets/images/research/audience.png";
import strategyIcon from "../../assets/images/research/strategy.png";
import statsIcon from "../../assets/images/research/stats.png";

const ResearchInsightsPage = () => {
  return (
    <section className="research-page">

      {/* HERO */}
      <div className="container research-hero">
        <h1>
          Research That Helps <br />
          <span className="gold">Decisions Move Forward</span>
        </h1>

        <p>
          Good strategy depends on good understanding. We support organizations
          with structured research and analytical thinking that clarifies markets,
          audiences, issues, and opportunities.
        </p>
      </div>

      {/* EXPERTISE SECTION */}
      <div className="container research-grid">

        <div className="research-card">
          <img src={marketIcon} alt="" />
          <h3>Market Understanding</h3>
          <div className="yellow-line"></div>
          <p>
            Category, competitive, and trend-oriented analysis.
          </p>
        </div>

        <div className="research-card">
          <img src={audienceIcon} alt="" />
          <h3>Audience & Perception Insight</h3>
          <div className="yellow-line"></div>
          <p>
            Understanding how stakeholders, users, or audiences think,
            respond, and decide.
          </p>
        </div>

        <div className="research-card">
          <img src={strategyIcon} alt="" />
          <h3>Strategic Analysis</h3>
          <div className="yellow-line"></div>
          <p>
            Turning complex information into practical,
            decision-ready insight.
          </p>
        </div>

        <div className="research-card">
          <img src={statsIcon} alt="" />
          <h3>Statistical Interpretation</h3>
          <div className="yellow-line"></div>
          <p>
            Using structured analysis to support business
            judgment where evidence matters.
          </p>
        </div>

      </div>

    </section>
  );
};

export default ResearchInsightsPage;